import React from "react";

// Always-visible build-version badge. Pinned bottom-right of the viewport
// so labelers (and you) can see at a glance which build they're on,
// regardless of which page they're on. Hover for the build timestamp.
const VersionBadge = () => {
  const sha = process.env.REACT_APP_GIT_SHA || "dev";
  const time = process.env.REACT_APP_BUILD_TIME || "local";
  return (
    <div
      title={`Build: ${sha} • ${time}`}
      style={{
        position: "fixed",
        bottom: 8,
        right: 10,
        zIndex: 9999,
        padding: "3px 9px",
        background: "rgba(15, 23, 42, 0.78)",
        color: "#e5e7eb",
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: "0.04em",
        borderRadius: 6,
        userSelect: "all",
        cursor: "help",
        pointerEvents: "auto",
        boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
      }}
    >
      v {sha}
    </div>
  );
};

export default VersionBadge;
